export default [
  //{code: 'is the generaric/default error and is defined elsewhere'},
  {
      code: 'G0001',
      user_message: 'A critical error has occurred.',
      support_message:
      'We attempted to access a patient specific route from a quick access button but we had no patient_id. This is a critical error for development to know about.'
  }
]